module.exports = __webpack_public_path__ + "static/img/chapter_close.be54d46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chapter_close.svg
// module id = 4x6Q
// module chunks = 1